import { render } from "./UserBillItem.vue?vue&type=template&id=43e07fd0&scoped=true"
import script from "./UserBillItem.vue?vue&type=script&lang=js"
export * from "./UserBillItem.vue?vue&type=script&lang=js"

import "./UserBillItem.vue?vue&type=style&index=0&id=43e07fd0&scoped=true&lang=css"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e07fd0"]])

export default __exports__